import { Injectable } from '@angular/core';
import { HeaderVariant } from '@challenger/care/components/header-wrapper/header.types';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AppLoadingService {  
  public showLoading$: Observable<boolean>;
  public setTheme$: Observable<HeaderVariant>;
  private showLoadingSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  private setThemeSubject: BehaviorSubject<HeaderVariant> = new BehaviorSubject<HeaderVariant>(HeaderVariant.secondary);


  constructor() {
    this.showLoading$ = this.showLoadingSubject.asObservable();
    this.setTheme$ = this.setThemeSubject.asObservable();
  }

  setTheme(themeVariant: HeaderVariant) {
    this.setThemeSubject.next(themeVariant);
  }

  showLoading(isLoading: boolean) {
    this.showLoadingSubject.next(isLoading);
  }
}
